import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
// import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
// import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
// import CustomButton from '../../../Components/CustomButton/CustomButton'
import CustomButton from '../../../../../../Components/CustomButton/CustomButton'

import ComboBox from '../../../../../../Components/ComboBox'
import { Input } from '../../../../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest, makePutRequest } from '../../../../../../utils/api'
import urls from '../../../../../../utils/urls'
import { Box } from '@mui/material'
import { currentDate, convertToMuiDate } from '../../../../../../utils/helpers'
import { useParams, useNavigate } from 'react-router-dom'

// import EditIcon from '@mui/icons-material/Edit'
// import ButtonGroup from '@mui/material/ButtonGroup'
// import Tooltip from '@mui/material/Tooltip'
// import { styled } from '@mui/material/styles'
// import UploadFileIcon from '@mui/icons-material/UploadFile'
// import Link from '@mui/material/Link'

// import Stack from '@mui/material/Stack'

export default function EditPlanFinancementOperationForm({
  setOperations,
  params,
  operations,
  setSelected,
}) {
  const [open, setOpen] = useState(false)
  const [selectedCreditor, setSelectedCreditor] = useState({})
  let id = ''
  const { objid } = useParams()

  // const log =  () =>{
  //   setValue( 'vehicleType', { label: `${params[0].vehicletypes.vehicletype}`, id: params[0].vehicletypes.id } )

  // }

  useEffect(() => {
    // fetchFinancementDetail()
    // fetchOperations()
  }, [])

  const getIdFromOperations = () => {
    if (operations.results) {
      id = operations.results[0].finciments.id
    }
  }
  const handleClickOpen = () => {
    setOpen(true)
    getIdFromOperations()
    fetchFinancementDetail()
  }

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      id: '',
      ObjectID: objid,
      BeginDate: currentDate(),
      TotalLoans: '',
      // Creditor: '',
      // Contact: '',
      YearsDuration: '',
    },
  })

  const fetchFinancementDetail = async () => {
    const response = await makeGetRequest(urls.curdFinancement + id, {}, true)
    if (response.status === 200) {
      setValue('id', response.data.id)
      setValue(
        'BeginDate',
        response.data.BeginDate ? convertToMuiDate(response.data.BeginDate) : '',
      )
      setValue('TotalLoans', response.data.TotalLoans)
      // setValue('Creditor',response.data.Creditor)
      // setSelectedCreditor(typeCreditor.filter((v) => v.label === response.data.Creditor)[0])
      // setValue('Contact',response.data.Contact)
      setValue('YearsDuration', response.data.YearsDuration)

      // setVehicule(response.data)
      // setRestToPay(response.data.RestToPay);
    }
  }
  const typeCreditor = [
    { label: 'Institutions_financiere', id: 1 },
    { label: 'Famille', id: 2 },
    { label: 'Amis', id: 3 },
  ]

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelected(false)
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }

    const response = await makePutRequest(urls.curdFinancement + `${data.id}/`, payload, {}, true)

    if (response.status === 200) {
      let url = `${urls.curdPlanFinancementViewDashboard}`
      const response = await makeGetRequest(url + '?vehicleObjectID=' + id, {}, true)
      if (response.status === 200) {
        setOperations({ ...response.data })
        handleClose()
      }
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>Modifier plan de financement</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle>Éditer financement</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="BeginDate"
              label="Begin Date"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="TotalLoans"
              label="Total Loans"
            />
            {/* <ComboBox
                handleAutoComplete={(e, j) => setValue('Creditor', j.label)}
                label="Creditor"
                data={typeCreditor}
                name="Creditor"
                required={true}
                selectedValue={selectedCreditor}
              />
             <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name='Contact'
              label='Contact'
            /> */}

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="YearsDuration"
              label="Years Duration"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
